<template>
  <div>
    <div class="header pb-3 d-flex" :class="autoTranslateEndpoint && 'justify-content-between'">
      <button class="btn btn-light" id="add-new-translation" @click="addNewTranslation">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 20 20" fill="currentColor">
          <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-11a1 1 0 10-2 0v2H7a1 1 0 100 2h2v2a1 1 0 102 0v-2h2a1 1 0 100-2h-2V7z" clip-rule="evenodd" />
        </svg>
        
        Vertaling uploaden
      </button>

      <button v-if="autoTranslateEndpoint" class="btn btn-light" id="add-new-translation" @click="autoTranslate">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 48 48">
          <g transform="matrix(3.4285714285714284,0,0,3.4285714285714284,0,0)"><g>
            <g>
              <path d="M6.5,13.5,9.64,6.17a.39.39,0,0,1,.72,0L13.5,13.5" style="fill: none;stroke: currentColor;stroke-linecap: round;stroke-linejoin: round"></path>
              <line x1="7.91" y1="10.21" x2="12.09" y2="10.21" style="fill: none;stroke: currentColor;stroke-linecap: round;stroke-linejoin: round"></line>
            </g>
            <line x1="0.5" y1="2.5" x2="9.5" y2="2.5" style="fill: none;stroke: currentColor;stroke-linecap: round;stroke-linejoin: round"></line>
            <line x1="5" y1="0.5" x2="5" y2="2.5" style="fill: none;stroke: currentColor;stroke-linecap: round;stroke-linejoin: round"></line>
            <line x1="8" y1="2.5" x2="2" y2="9.5" style="fill: none;stroke: currentColor;stroke-linecap: round;stroke-linejoin: round"></line>
            <line x1="2" y1="2.5" x2="5.94" y2="7.1" style="fill: none;stroke: currentColor;stroke-linecap: round;stroke-linejoin: round"></line>
          </g></g>
        </svg>
        
        Automatisch vertalen
      </button>
    </div>

    <div class="translations-wrapper"
      id="translations-wrapper"
      :class="{
        loading,
        empty: !translationsList.length,
      }"
    >
      <ul v-if="loading" class="pt-3">
        <TranslationItem v-for="(trans, i) in placeholder" :key="trans.name + i"
          v-bind="trans"
          :ske="true"
        />
      </ul>
      <div v-else-if="!translationsList.length" class="empty-state-wrapper d-flex justify-content-center align-items-center">
        <EmptyStatePlaceholder
          title="Dit product heeft geen vertalingen"          
        >
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
            <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM4.332 8.027a6.012 6.012 0 011.912-2.706C6.512 5.73 6.974 6 7.5 6A1.5 1.5 0 019 7.5V8a2 2 0 004 0 2 2 0 011.523-1.943A5.977 5.977 0 0116 10c0 .34-.028.675-.083 1H15a2 2 0 00-2 2v2.197A5.973 5.973 0 0110 16v-2a2 2 0 00-2-2 2 2 0 01-2-2 2 2 0 00-1.668-1.973z" clip-rule="evenodd" />
          </svg>
        </EmptyStatePlaceholder>
      </div>
      <ul v-else class="pt-3" id="translations-list">
        <TranslationItem v-for="(trans, index) in translationsList" :key="trans.name"
          v-bind="trans"

          :showAutotranslated="showAutotranslated"

          @click.native="editTranslation(trans)"
          @remove="remove(trans, index)"
        />
      </ul>
    </div>
  </div>
</template>

<script>

import EmptyStatePlaceholder from "../EmptyStatePlaceholder.vue"
import TranslationItem from "./TranslationItem.vue"

const placeholder = {
  lang: "de",
  short_description: "Morbi enim nunc faucibus a pellentesque sit amet. Etiam tempor orci eu lobortis. Turpis massa tincidunt dui ut ornare lectus. Ornare suspendisse sed nisi lacus sed viverra tellus. Dignissim sodales ut eu sem. Morbi enim nunc faucibus a pellentesque sit amet. Etiam tempor orci eu lobortis. Turpis massa",
  name: "Enim neque volutpat",
}

export default {
  components: {
    TranslationItem,
    EmptyStatePlaceholder,
  },
  props: {
    value: Object,
    
    simpleTranslation: Boolean,
    autoTranslateEndpoint: String,
    simpleTranslationPlaceholder: String,
    parseTranslationParams: Function,

    productData: Object,

    showAutotranslated: {
      type: Boolean,
      default: true,
    },
    
    emptyStateTitle: {
      type: String,
      required: true,
    },
    emptyStateDescription: {
      type: String,
      required: false,
    },
    callback: {
      type: Function,
      required: false,
    },
    
    endpoint: String,
  },
  async created() {
    await this.loadTranslations()
  },
  data() {
    return {
      loading: false,
      translations: {},
      placeholder: [
        placeholder,
        placeholder,
        placeholder,
      ]
    }
  },
  methods: {
    async autoTranslate() {
      this.$handlePromise(async () => {
        await this.axios.put(this.autoTranslateEndpoint, this.productData)
        await this.loadTranslations()

        this.$success('Succesvol automatisch vertaalde inhoud!')
      })
    },
    async loadTranslations() {
      this.loading = true
      if (this.endpoint) {
        this.translations = (await this.axios.get(this.endpoint)).data || {}
      } else {
        this.translations = this.value
      }
      this.loading = false
    },
    async remove({lang, name}, index) {
      if (this.endpoint) {
        if (await this.$handlePromise(
          this.axios.delete(this.endpoint + `/${lang}`)
        )) {
          this.$success(`De vertaling <b>"${name}"</b> is verwijderd!`)
          await this.loadTranslations()
        }
      } else {
        const obj = {...this.translations}
        delete obj[lang]
        this.$emit("input", obj)
        this.updateLocalTranslationVariable()
      }
    },
    async addItemToTemporaryTranslationArr(payload) {
      this.$emit("input", {
        ...this.translations,
        [payload.language]: {
          ...payload.translation,
        }
      })
      this.updateLocalTranslationVariable()
    },
    updateLocalTranslationVariable() {
      this.$nextTick(() => this.translations = this.value)
    },
    openTranslationModal(item) {
      this.$pushModal({
        modal: "EditTranslation",
        toBind: {
          endpoint: this.endpoint,
          item,
          goBack: this.callback,
          callback: this.endpoint ? this.loadTranslations : this.addItemToTemporaryTranslationArr,

          simpleTranslation: this.simpleTranslation,
          simpleTranslationPlaceholder: this.simpleTranslationPlaceholder,
          parseTranslationParams: this.parseTranslationParams,
        },
      })
    },
    editTranslation(item) {
      this.openTranslationModal(item)
    },
    addNewTranslation() {
      this.openTranslationModal()
    },
  },
  computed: {
    translationsList() {
      const trans = this.translations
      return Object.keys(trans).map(key => ({ ...trans[key], lang: key }))
    },
  },
}

</script>

<style scoped>

.header {
  border-bottom: 1px solid rgba(0, 0, 0, 0.125);
}

.translations-wrapper, .empty-state-wrapper {
  min-height: 450px;
}

</style>
